import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import MailIcon from '@mui/icons-material/Mail';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import RouteIcon from '@mui/icons-material/Route';

import {
    Link as RouterLink,
    useLocation,
} from "react-router-dom";

export default function MainListItems ()  {
  let location = useLocation();
  let url = location.pathname;

  return (
  <div>
    <RouterLink to={`${url}`}>
    <ListItem button>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/usuarios`}>
    <ListItem button>
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Usuarios" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/busbases`}>
    <ListItem button>
      <ListItemIcon>
        <LocationOnIcon />
      </ListItemIcon>
      <ListItemText primary="Bus Bases" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/bustipos`}>
    <ListItem button>
      <ListItemIcon>
        <DirectionsBusIcon />
      </ListItemIcon>
      <ListItemText primary="Bus Tipos" />
    </ListItem>
    </RouterLink>
    {/*Tarea GDM-700 - Inicio */}
    <RouterLink to={`${url}/emails`}>
    <ListItem button>
      <ListItemIcon>
        <DirectionsBusIcon />
      </ListItemIcon>
      <ListItemText primary="Emails" />
    </ListItem>
    </RouterLink>
    {/*Tarea GDM-700 - Fin */}
    <RouterLink to={`${url}/cotizaciones`}>
    <ListItem button>
      <ListItemIcon>
        <RequestQuoteIcon />
      </ListItemIcon>
      <ListItemText primary="Cotizaciones" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/mailtemplates`}>
    <ListItem button>
      <ListItemIcon>
        <MailIcon />
      </ListItemIcon>
      <ListItemText primary="Mail Templates" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/precios`}>
    <ListItem button>
      <ListItemIcon>
        <AttachMoneyIcon />
      </ListItemIcon>
      <ListItemText primary="Precios" />
    </ListItem>
    </RouterLink>

    <RouterLink to={`${url}/rutas`}>
    <ListItem button>
      <ListItemIcon>
        <RouteIcon />
      </ListItemIcon>
      <ListItemText primary="Rutas" />
    </ListItem>
    </RouterLink>

    <ListItem button>
      <ListItemIcon>
        <BarChartIcon />
      </ListItemIcon>
      <ListItemText primary="Reportes" />
    </ListItem>
  </div>
)};
